import fetch from 'isomorphic-fetch';
import { push } from 'react-router-redux';
import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';
import { Event } from "../../GAnalytics";

export function getToken(username, password) {
	return function(dispatch, getState) {

		// Builds credentials
		const URL = `${ROOT}/auth/login/`;
		const auth = Buffer.from(username + ':' + password).toString('base64');

		// Set visual UI
		dispatch(isFetching(true));

		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Basic ' + auth,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			Event('Login', 'getToken', 'Entrou.', username);

			let loginData = {};

			loginData.projectaccess = json.permissions.filter((perm) => perm.startsWith('access_'));
			
			loginData.choosenbyuser = { isMariana: false, isBrumadinho: false }; 
			loginData.choosenbyuser.isMariana = json.permissions.includes("access_mariana"); 
			loginData.choosenbyuser.isBrumadinho = json.permissions.includes("access_brumadinho");
			loginData.choosenbyuser.isAssistenciaTecnica = json.permissions.includes("access_assistencia_tecnica");
			
			loginData.groupaccess = json.groups;
			
			loginData.credentials = { username: json.user.username, token: json.token };
			
			loginData.isAdmin = json.permissions.includes("change_user"); 
			loginData.isAdminPlus = json.permissions.includes("change_loginlog"); 
			loginData.isGisAdmin = json.permissions.includes("change_maplayer");
			loginData.isGisOnly = json.permissions.includes("access_somente_gis");
			
			dispatch(setLoginData(loginData));

			const home = loginData.isGisOnly ? '/admin/documents/explorer' : '/';
			
			dispatch(push(home));			
		})
		.catch((e) => {
			dispatch(isFetching(false));
			console.error(e);
		});
	};
}

export function logout() {
	Event('Login', 'logout', 'Deslogou.');
	return function(dispatch, getState) {
		const URL = `${ROOT}/auth/logout/`;
		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token				
			}			
		})
		.finally(() => {
			dispatch(resetLoginData());	
			dispatch(push('/login'));
			localStorage.clear();
		});		
	};
}

export function isTokenValid() {
	return function(dispatch, getState) {		
		dispatch(isFetching(true));
		const URL = `${ROOT}/auth/token/`;
		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then(() => dispatch(isFetching(false)))
		.catch((e) => {
			dispatch(isFetching(false));
			console.error(e);
		});
	};
}

export function changePassword(newPw, currPw, onSuccess, onError) {
	Event('Login', 'changePassword', 'Alterou a senha de acesso.');
	return function(dispatch, getState) {

		const URL = `${ROOT}/user/change_password/`;
		const json = { new_password: newPw, old_password: currPw };

		return fetch(URL, {
			method: 'PUT',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		})
		.then((response) => checkStatus(response, dispatch))
		.then(() => onSuccess())
		.catch((e) => {
			onError();
			console.error(e);
		});
	};
}

export function newPassword(newPw, token, onSuccess, onError) {
	Event('Login', 'newPassword', 'Resetou a senha de acesso.');
	return function(dispatch, getState) {

		const URL = `${ROOT}/user/new_password/`;
		const json = { new_password: newPw, token: token };

		return fetch(URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		})
		.then((response) => checkStatus(response, dispatch))
		.then(response => response.json())
		.then((json) => {
			dispatch(getToken(json.username, newPw));
		})
		.catch((e) => {
			onError();
			console.error(e);
		});
	};
}

export function resetPassword(email, onSuccess, onError) {
	Event('Login', 'resetPassword', 'Tentou resetar a senha.');
	return function(dispatch, getState) {

		const URL = `${ROOT}/user/reset_password/`;
		const json = { email: email };

		return fetch(URL, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		})
		.then((response) => checkStatus(response, dispatch))
		.then(() => onSuccess())
		.catch((e) => {
			onError();
			console.error(e);
		});
	};
}

// export function getProjectPermission(onSuccess, onError) {
// 	return function(dispatch, getState) {

// 		const URL = `${ROOT}/user/get_permissions/`;
		
// 		return fetch(URL, {
// 			method: 'GET',
// 			headers: {
// 				'Authorization': 'Token ' + getState().login.credentials.token,
// 				'Content-Type': 'application/json'
// 			}
// 		})
// 		.then((response) => checkStatus(response, dispatch))
// 		.then(response => response.json())
// 		.then(data => {
// 			dispatch(setProjectAccess(data));
// 		})
// 		.catch((e) => {
// 			onError();
// 			console.error(e);
// 		});
// 	};
// }

export function setLoginData(loginData) {
	return {
		type: "SET_LOGIN_DATA",
		loginData: loginData
	};
}

export function resetLoginData() {
	return {
		type: "RESET_LOGIN_DATA"
	};
}

export function setChoosenByUser(isMariana, isBrumadinho, isAssistenciaTecnica = false) {
	return {
		type: "SET_CHOOSEN_BY_USER",
		isMariana,
		isBrumadinho,
		isAssistenciaTecnica
	};
}
export function setCredentials(token, username) {
	return {
		type: "SET_CREDENTIALS",
		token,
		username
	};	
}

// export function setProjectAccess(projectaccess) {
// 	return {
// 		type: "SET_PROJECT_ACCESS",
// 		projectaccess
// 	};
// }

export function setMessage(message) {
	return {
		type: "SET_MESSAGE",
		message
	};	
}

function isFetching(bool) {
	return {
		type: "IS_FETCHING",
		bool
	};	
}


// WEBPACK FOOTER //
// ./src/state/login/actions.js